import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function parseDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return new Date(0);
  // Suporta formato YYYY-MM-DD (Django) e DD/MM/YYYY
  if (dateStr.includes('-')) {
    return new Date(dateStr);
  }
  const [day, month, year] = dateStr.split('/').map(Number);
  return new Date(year, month - 1, day);
}

export const useChallengeData = () => {
  const [challengeHistory, setChallengeHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/challenges/?limit=1000`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        // API Django retorna paginado com results ou array direto
        const rawChallenges = data.results || data;
        // Mapear campos Django (snake_case) para frontend (camelCase)
        const challenges = rawChallenges.map(ch => ({
          ...ch,
          totalOdd: parseFloat(ch.total_odd) || 0,
          amount: parseFloat(ch.amount) || 0,
          addedAmount: parseFloat(ch.added_amount) || 0,
          games: (ch.games || []).map(game => ({
            ...game,
            gameOdd: parseFloat(game.game_odd) || 0,
            homeTeam: game.home_team || '',
            awayTeam: game.away_team || null,
            pickDescription: game.pick_description || '',
          }))
        }));
        setChallengeHistory(challenges);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const interval = setInterval(fetchData, 30000);

    return () => clearInterval(interval);
  }, []);

  const sortedHistory = challengeHistory.slice().filter(ch => ch && ch.date && ch.games).sort((a, b) => {
    const dateDiff = parseDate(b.date) - parseDate(a.date);
    if (dateDiff !== 0) return dateDiff;
    return b.id - a.id;
  });
  const challengeData = sortedHistory.length > 0 ? sortedHistory[0] : null;

  return { challengeHistory: sortedHistory, challengeData, loading, error };
};